module.exports = function () {
    const ispageNav = document.querySelector('.page-nav') !== null;

    if (!ispageNav) {
        return
    }

    let pageNav = document.querySelector('.page-nav'),
        pageNavPosition = null,
        currentScrollPosition = window.scrollY || window.scrollTop,
        isScrolledToNav = false;

    const checkPageNavPosition = () => {
        pageNavPosition = pageNav.getBoundingClientRect().top + document.documentElement.scrollTop;
    }

    const checkScrollPosition = () => {
        currentScrollPosition = window.scrollY || window.scrollTop;

        if (currentScrollPosition >= pageNavPosition) {
            isScrolledToNav = true;
        } else {
            isScrolledToNav = false;
        }

        toogleNavClass();
    }

    const toogleNavClass = () => {
        if (isScrolledToNav) {
            pageNav.classList.add('page-nav--scrolled');
        } else {
            pageNav.classList.remove('page-nav--scrolled');
        }
    }

    checkPageNavPosition();
    checkScrollPosition();
    toogleNavClass();

    window.addEventListener("resize", checkPageNavPosition);
    window.addEventListener("resize", checkScrollPosition);
    window.addEventListener("scroll", checkScrollPosition);
}